// Values `filters.status` can hold that are NOT Odoo employment statuses.
// Shared by OrgChartPage (which interprets them in `matches`) and
// OrgStatsStrip (whose tiles write them).

// Sentinel `filters.status` value meaning "seats only". Seats are a `kind`,
// not an employment status, so they cannot be threaded through as a real
// status string without colliding with a genuine label an admin might type
// in Odoo. The Status <select> never renders it as an option, and the page's
// `matches` is the only place that interprets it.
export const SEATS_STATUS_FILTER = '__seats__';

// Sentinel `filters.status` value meaning "open positions that have an acting
// employee covering them". Same reasoning as SEATS_STATUS_FILTER: acting cover
// is a property of the seat, not an employment status, so it cannot be threaded
// through as a status string without colliding with a label an admin might type
// in Odoo. Interpreted only in `matches`, never offered by the Status select.
export const ACTING_STATUS_FILTER = '__acting__';

// The four named status tiles do not cover every employment status Odoo can
// return: live data also carries "Maternity leave", "Unpaid vacation" and
// whatever HR adds next. Without this the breakdown silently failed to add up
// to the positions total. Same sentinel reasoning as the two above — it is a
// set complement, not a status string, so it cannot be a real status value.
export const OTHER_STATUS_FILTER = '__other__';

// Sentinel `filters.status` value meaning "people only" (every filled card, no
// open seats). What the Employees headline selects. Like the seats sentinel it
// tests `kind`, not a status, so it cannot collide with an Odoo label.
export const PEOPLE_STATUS_FILTER = '__people__';

// The statuses that have a tile of their own. `Other` is everything filled that
// is NOT one of these, so adding a tile here automatically removes that status
// from Other and the two stay consistent by construction.
export const NAMED_STATUSES = ['Active', 'Probation', 'On Notice', 'PIP'];
